"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const castNumberToCoordinate_1 = __importDefault(require("../../../shared/castNumberToCoordinate"));
const getNumberFromUnknown_1 = __importDefault(require("../../../shared/getNumberFromUnknown"));
const reduceValidCircle = (circles, getColorFromSpecification) => Object.entries(circles)
    .reduce((newCircles, [circleId, circle]) => {
    const latitudeValue = (0, castNumberToCoordinate_1.default)(circle.latitude);
    const longitudeValue = (0, castNumberToCoordinate_1.default)(circle.longitude);
    let radius;
    try {
        radius = (0, getNumberFromUnknown_1.default)((circle === null || circle === void 0 ? void 0 : circle.radius) || 200);
    }
    catch (_a) {
        radius = undefined;
    }
    const strokeWidth = (0, getNumberFromUnknown_1.default)((circle === null || circle === void 0 ? void 0 : circle.strokeWidth) || 2);
    const strokeColor = getColorFromSpecification(circle === null || circle === void 0 ? void 0 : circle.strokeColor) || '#003892';
    const fillColor = getColorFromSpecification(circle === null || circle === void 0 ? void 0 : circle.fillColor) || '#003892';
    if (latitudeValue && longitudeValue && radius) {
        return Object.assign(Object.assign({}, newCircles), { [circleId]: {
                center: {
                    latitude: latitudeValue,
                    longitude: longitudeValue,
                },
                radius,
                strokeWidth,
                strokeColor,
                fillColor,
            } });
    }
    return newCircles;
}, {});
exports.default = reduceValidCircle;
